import type { AccessGates, AccessInfo } from './use-access'

/** The route-gate decision on its own, without the 403 rendering. */
export interface AccessRule {
  gate?: keyof AccessGates
  when?: (access: AccessInfo) => boolean
}

/**
 * Pure form of the `RequireAccess` decision — `when` wins over `gate`, and no
 * rule means allowed. Exported so non-route callers (the product walkthrough)
 * decide eligibility with exactly the same semantics as the route guard.
 */
export function isAccessAllowed(access: AccessInfo, { gate, when }: AccessRule = {}): boolean {
  return when ? when(access) : gate ? Boolean(access[gate]) : true
}
